module.exports = __webpack_public_path__ + "img/ukflag.a6f83854.svg";